import { createFileRoute } from '@tanstack/react-router';
import { MyViolationsPage } from '@/features/fleet/MyViolationsPage';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileMyViolations } from '@/features/fleet/mobile/MobileMyViolations';

/**
 * I verbali a proprio nome. Pagina a sé e non una tab delle prenotazioni: una multa non è
 * una cosa che hai chiesto tu, e in fondo a una pagina di richieste la troverebbe solo chi
 * la sta già cercando.
 */
export const Route = createFileRoute('/_app/my-violations')({ component: MyViolationsRoutePage });

/** Selettore mobile/desktop: su telefono la tabella da 980px diventa una lista di card. */
function MyViolationsRoutePage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileMyViolations /> : <MyViolationsPage />;
}
